import React, { useEffect, useState } from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";
import { FormEditFaq } from "./FormEditFaq";

export const PanelEditFaq = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({
    title: "",
    description: "",
  });
  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.Faqs.GetOne}/${id}`,
      });

      if (response) {
        setData({
          title: response.data.title || "",
          description: response.data.description || "",
        });
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      {" "}
      <PanelHead
        title={
          isLoading ? (
            <div className="flex items-center gap-4">
              Edit Faq <CircularProgress size={24} />
            </div>
          ) : (
            <div className="flex items-center justify-between w-full gap-4">
              <div>Edit Faq: {data?.title}</div>
            </div>
          )
        }
      />
      <PanelBody
        content={
          isLoading ? (
            <LinearProgress />
          ) : (
            <FormEditFaq data={data} setData={setData} />
          )
        }
      />
    </div>
  );
};
